/** Couleurs standard (style PowerPoint, palette simplifiée). */
export const U3140_PDF_ANNOTATION_SWATCH_COLORS = [
  "#000000",
  "#FFFFFF",
  "#C00000",
  "#FF0000",
  "#FFC000",
  "#FFFF00",
  "#92D050",
  "#00B050",
  "#00B0F0",
  "#0070C0",
  "#002060",
  "#7030A0",
] as const;

/** Valeur sentinelle : pas de remplissage (rectangle). */
export const U3140_PDF_ANNOTATION_FILL_NONE = "transparent";

/** Compatibilité imports historiques u3142Lot. */
export const U3142_PDF_ANNOTATION_FILL_NONE = U3140_PDF_ANNOTATION_FILL_NONE;
export const U3142_PDF_ANNOTATION_SWATCH_COLORS = U3140_PDF_ANNOTATION_SWATCH_COLORS;
